<div class="card">
  <h2 class="ml-3 mt-2">Orçamento para tradução</h2>
  <div class="card-body">
    <form [formGroup]="translateForm">
      <div class="row">
        <div class="col-md-4 form-group">
          <label for="language_primary">De</label>
          <select class="custom-select form-control" id="language_primary" formControlName="language_primary"
            [ngClass]="{ 'is-invalid': translateFormSubmitted && translateForm.get('language_primary').hasError('required') }">
            <option *ngFor="let lang of language" [value]="lang.id">{{ lang.type }}</option>
          </select>
        </div>
        <div class="col-md-4 form-group">
          <label for="language_secondary">Para</label>
          <select class="custom-select form-control" id="language_secondary" formControlName="language_secondary"
            [ngClass]="{ 'is-invalid': translateFormSubmitted && translateForm.get('language_secondary').hasError('required') }">
            <option *ngFor="let lang of language" [value]="lang.id">{{ lang.type }}</option>
          </select>
        </div>
        <div class="col-md-4 form-group">
          <label for="quantity_lauda">Quantidade de Laudas</label>
          <input type="number" formControlName="quantity_lauda" class="form-control" id="quantity_lauda"
            [ngClass]="{ 'is-invalid': translateFormSubmitted && translateForm.get('quantity_lauda').hasError('required') }">
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 form-group">
          <label for="subject_matter">Área de Conhecimento</label>
          <select class="custom-select form-control" id="subject_matter" formControlName="subject_matter"
            [ngClass]="{ 'is-invalid': translateFormSubmitted && translateForm.get('subject_matter').hasError('required') }">
            <option *ngFor="let subject of subjectMatter" [value]="subject.id">{{ subject.type }}</option>
          </select>
        </div>
        <div class="col-md-4 form-group">
          <label for="delivery_date">Data de Entrega</label>
          <input type="date" formControlName="delivery_date" class="form-control"
            [ngClass]="{ 'is-invalid': translateFormSubmitted && translateForm.get('delivery_date').hasError('required') }">
        </div>
        <div class="col-md-4 d-flex form-group value">
          <button type="button" class="button button-green" (click)="calcPrice()">Calcular Preço</button>
          <input type="text" class="form-control" style="width: 40%;" name="translatePrice" id="translatePrice"
            placeholder="R$00,00" disabled>
        </div>
      </div>
    </form>

    <div class="mt-lg-2 mt-3">
      <span class="mr-2">Pagar após a entrega</span>
      <p class="mt-2">
        Nós confiamos em você: sinta-se à vontade para pagar
        em até 5 dias após a entrega, via transferência bancária
        ou cartão de crédito.
      </p>
    </div>

  </div>
</div>